/**
 * Creates a stable hash from an object.
 *
 * This is all ripped directly from Stitches, so we may want to modify it in final version.
 */

const toAlphabeticChar = (code: number): string =>
  String.fromCharCode(code + (code > 25 ? 39 : 97));

const toAlphabeticName = (code: number): string => {
  let name = '';
  let x;

  for (x = Math.abs(code); x > 52; x = (x / 52) | 0)
    name = toAlphabeticChar(x % 52) + name;

  return toAlphabeticChar(x % 52) + name;
};

const toPhash = (h: number, x: string): number => {
  let i = x.length;
  while (i) h = (h * 33) ^ x.charCodeAt(--i);
  return h;
};

/**
 * Converts a function into its own string.
 * In the case of an atom, that is its atomic hash
 * In the case of a Styled Component, it will be its selector hash.
 *
 * This ensures that a Styled Component whose only purpose is to compose atoms, will still have a unique selector hash of its own.
 */
const functionToString = (key: string, val: any) => {
  if (typeof val === 'function') {
    return val.toString();
  }
  return val;
};

export const toHash = (value: Record<any, any>): string =>
  toAlphabeticName(
    toPhash(5381, JSON.stringify(value, functionToString)) >>> 0
  );
